import { AnnouncementTileBackgroundType } from ".";

export const getDismissButtonVariant = (type: AnnouncementTileBackgroundType) => {
  switch (type) {
    case AnnouncementTileBackgroundType.Clouds:
      return "ghostInversed";
    case AnnouncementTileBackgroundType.Planets:
      return "ghostInversed";
    case AnnouncementTileBackgroundType.IacConf:
      return "ghost";
  }
};
